/*
  One scroll lock for every overlay in the theme.

  There were four separate implementations of `body { overflow: hidden }` (cart
  drawer, search drawer, mobile menu, collection filter) plus a fifth that used
  position: fixed (the video modal). The overflow approach did not actually hold:
  the html element carries `overflow-x: clip`, and CSS only propagates body's
  overflow to the viewport when html's overflow is `visible`, so the page kept
  scrolling behind every one of those panels. iOS Safari ignores it regardless.

  This locks with position: fixed and an offset equal to the current scroll
  position, which holds on iOS, and restores the exact position on release.

  Reference counted by key, so a video modal opened from inside the cart drawer
  does not unlock the page when only the modal closes.

    window.NanoleafScrollLock.lock('cart-drawer');
    window.NanoleafScrollLock.unlock('cart-drawer');
*/
(function () {
  if (window.NanoleafScrollLock) return;

  var holders = [];
  var savedY = 0;
  var saved = {};

  function has(key) {
    return holders.indexOf(key) !== -1;
  }

  function apply() {
    var body = document.body;
    savedY = window.scrollY || document.documentElement.scrollTop || 0;

    /* Removing the scrollbar would shift the whole page sideways, which reads as
       the layout jumping the moment a panel opens. Pad by exactly its width. */
    var gutter = window.innerWidth - document.documentElement.clientWidth;

    saved = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      paddingRight: body.style.paddingRight
    };

    if (gutter > 0) body.style.paddingRight = gutter + 'px';
    body.style.position = 'fixed';
    body.style.top = -savedY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.classList.add('nf-scroll-locked');
  }

  function release() {
    var body = document.body;
    body.classList.remove('nf-scroll-locked');
    body.style.position = saved.position || '';
    body.style.top = saved.top || '';
    body.style.left = saved.left || '';
    body.style.right = saved.right || '';
    body.style.width = saved.width || '';
    body.style.paddingRight = saved.paddingRight || '';

    /* Jump, never animate. A theme-level `scroll-behavior: smooth` would
       otherwise scroll the page back up in front of the shopper. */
    var root = document.documentElement;
    var prevBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, savedY);
    root.style.scrollBehavior = prevBehavior;
  }

  window.NanoleafScrollLock = {
    lock: function (key) {
      if (!key || has(key)) return;
      var wasOpen = holders.length > 0;
      holders.push(key);
      if (!wasOpen) apply();
    },

    unlock: function (key) {
      var i = holders.indexOf(key);
      if (i === -1) return;
      holders.splice(i, 1);
      if (holders.length === 0) release();
    },

    isLocked: function () {
      return holders.length > 0;
    }
  };
})();
